import { LogEvent } from 'src/app/interfaces/log';
import { EventLoggingParams, LogEventKey } from '../../../interfaces/log';
import { LogService } from '../log.service';

export class MbtiBestFriendLogService {
  constructor(private logService: LogService) { }

  bestFriendResultBestFriendButtonClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_BEST_FRIEND_BUTTON_CLICKED);
  }

  bestFriendResultMbtIButtonViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_MBTI_BUTTON_VIEWED);
  }

  bestFriendRankClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RANK_CLICKED);
  }

  bestFriendResultMbtIButtonClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_MBTI_BUTTON_CLICKED);
  }

  bestFriendResultShareButtonClicked(type: 'kakao' | 'copy'): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_SHARE_BUTTON_CLICKED, { type });
  }

  bestFriendResultResultScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_RESULT_SCREEN_VIEWED);
  }

  bestFriendMatchScreenViewed(type: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.BEST_FRIEND_MATCH_SCREEN_VIEWED, { type });
  }

  bestFriendQuestionnaireScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_QUSTIONNAIRE_SCREEN_VIEWED);
  }

  bestFriendIntroScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_INTRO_SCREEN_VIEWED);
  }

  bestFriendChemiButtonClicked(type: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.BEST_FRIEND_CHEMI_BUTTON_CLICKED, { type });
  }

  bestFriendGuestIntroScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_INTRO_SCREEN_VIEWED);
  }

  bestFriendGuestMbtIChooseScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_MBTI_CHOOSE_SCREEN_VIEWED);
  }

  bestFriendGuestMbtiChose(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_MBTI_CHOSE);
  }

  bestFriendGuestMbtINeededScreenViewed(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_MBTI_NEEDED_SCREEN_VIEWED);
  }

  bestFriendGuestMbtIButtonClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_MBTI_BUTTON_CLICKED);
  }

  logHomeBestFriendClicked(): void {
    this.eventLogging(LogEvent.HOME_SOCIAL_CONTENT_BEST_FRIEND_CLICKED);
  }

  logBestFriendResultViewCompatibilityBannerClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_VIEW_COMPATIBILITY_BANNER_CLICKED);
  }

  logBestFriendResultHomeButtonClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_HOME_BUTTON_CLICKED);
  }

  logGuestNewMbtiButtonClicked(): void {
    this.eventLogging(LogEvent.BEST_FRIEND_GUEST_NEW_MBTI_BUTTON_CLICKED);
  }

  logBestFriendResultContentBannerClicked(title: string): void {
    this.eventLogging(LogEvent.BEST_FRIEND_RESULT_CONTENT_BANNER_CLICKED, { title });
  }
  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...params
    });
  }
}